import { render, staticRenderFns } from "./BranchAdd.vue?vue&type=template&id=18ec5a7d&scoped=true"
import script from "./BranchAdd.vue?vue&type=script&lang=js"
export * from "./BranchAdd.vue?vue&type=script&lang=js"
import style0 from "./BranchAdd.vue?vue&type=style&index=0&id=18ec5a7d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ec5a7d",
  null
  
)

export default component.exports